<div *ngIf="showSyncMessage" class="assessments-sync-message">
    <span class="assessments-sync-message-close">
        <i class="fa fa-times pointer" (click)="toggleSyncMessage()"></i>
    </span>
    <span [innerHTML]="syncMessage"></span>
    <span class="emerald cursor-pointer" [hidden]="!displayNavigationToAssessments">
        <span class="pl-4" (click)="goToAssessments()">
            Yes
        </span>
        <span class="pl-3" (click)="toggleSyncMessage()">
            No
        </span>
    </span>
</div>
